import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9u4hetca23r0tr1aqe0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      if (res.ok) {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，我们将定期为你推送精彩内容。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(responseText || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-accent-500/10">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-5">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
          订阅熟女魅力资讯
        </h2>
        <p className="text-foreground-500 font-label text-sm mb-8">
          每周获取最新的熟女时尚穿搭、护肤保养和生活美学灵感，让你的魅力更加耀眼动人
        </p>

        {status === 'success' ? (
          <div className="bg-accent-100 text-accent-700 rounded-xl p-5 text-sm font-label">
            {message}
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="company_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入你的邮箱地址"
              required
              className="flex-1 px-5 py-3.5 rounded-full border border-background-300 bg-background-50 text-sm font-label text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="whitespace-nowrap px-8 py-3.5 bg-primary-500 hover:bg-primary-600 disabled:opacity-50 text-background-50 font-label font-medium rounded-full transition-all duration-300 text-sm cursor-pointer"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="text-red-500 text-sm mt-3 font-label">{message}</p>
        )}

        <p className="text-xs text-foreground-400 font-label mt-4">
          我们尊重你的隐私，不会发送垃圾邮件，可随时退订
        </p>
      </div>
    </section>
  );
}